import { render, staticRenderFns } from "./BlocVisites.vue?vue&type=template&id=5df63fd6&"
import script from "./BlocVisites.vue?vue&type=script&lang=js&"
export * from "./BlocVisites.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports